lmApp
  .service('YoutubeService', ['$rootScope', '$templateCache', '$compile', '$q', '$timeout', '$http', 'AssetService', 'MetadataService', 'ModalWindowService', 'ToastService', 'ValidatorService',
    function ($rootScope, $templateCache, $compile, $q, $timeout, $http, AssetService, MetadataService, ModalWindowService, ToastService, ValidatorService) {
      var service = {};
      /**
       * Fetch data from IMDB
       * @param stream
       * @param assetType
       * @param $scope
       */
      service.FetchFromYoutube = function ($scope, stream, assetType) {
        var youtubeInnerScope = $scope.$new(true);

        youtubeInnerScope.searchField = stream.streamNew || stream.source || '';
        youtubeInnerScope.youtubeCollection = [];

        youtubeInnerScope.isSelected = function (index) {
          return index === youtubeInnerScope.selected.index;
        };

        youtubeInnerScope.selectItem = function (channel, index) {
          youtubeInnerScope.selected = channel;
          youtubeInnerScope.selected.index = index;
        };

        youtubeInnerScope.searchFromYoutube = function (channel) {
          if (!channel) return;
          youtubeInnerScope.youtubeCollection = [];

          var url;
          var isYoutube = false;
          var type = '';
          var userlId = null;
          var channelId = null;
          var videoId = null;

          if (assetType === 'channel') {

            if (ValidatorService.youtubeChannelRegExp.test(channel)) {
              type = 'channel';
              channelId = channel.match(ValidatorService.youtubeChannelRegExp)[1];
              isYoutube = true;
            }
            if (ValidatorService.youtubeUserRegExp.test(channel)) {
              type = 'user';
              userlId = channel.match(ValidatorService.youtubeUserRegExp)[1];
              isYoutube = true;
            }
          } else {

            if (ValidatorService.youtubeVideoRegExp.test(channel)) {
              type = 'video';
              videoId = channel.match(ValidatorService.youtubeVideoRegExp)[1];
              isYoutube = true;
            }
          }

          if (isYoutube) {
            youtubeInnerScope.loading = true;

            $rootScope.showLinearProgress('#fetcherLoader');

            if (type === 'user') {
              url = 'https://www.googleapis.com/youtube/v3/channels?part=id,snippet&forUsername= ' + userlId + '&key=AIzaSyA0IUlaOotw8UDNkqLRFXkTH37kPBmVrJg';
            }

            if (type === 'channel') {
              url = 'https://www.googleapis.com/youtube/v3/channels?part=id,snippet&id= ' + channelId + '&key=AIzaSyA0IUlaOotw8UDNkqLRFXkTH37kPBmVrJg';
            }

            if (type === 'video') {
              url = 'https://www.googleapis.com/youtube/v3/videos?part=id,snippet&id= ' + videoId + '&key=AIzaSyA0IUlaOotw8UDNkqLRFXkTH37kPBmVrJg';
            }

            $http.get(url)
              .then(function (res) {
                var response = res.data;

                youtubeInnerScope.loading = false;
                $rootScope.hideLinearProgress('#fetcherLoader');
                if (!response.items.length) {
                  ToastService.Big({
                    title: 'Searching for "' + channel + '"',
                    text: 'No result for this URL',
                    color: 'amber',
                    icon: 'emoticon-sad'
                  }, 60 * 1000);
                  return;
                }

                if (response.items.length) {
                  youtubeInnerScope.youtubeCollection = response.items.map(function (channel) {
                    return {
                      title: channel.snippet.title,
                      description: channel.snippet.description,
                      logo: channel.snippet.thumbnails.high.url,
                      stream: youtubeInnerScope.searchField,
                      id: channelId || userlId || videoId,
                      date: moment(channel.snippet.publishedAt),
                      type: type
                    }
                  });

                  service.AutoFill($scope.assetData, youtubeInnerScope.youtubeCollection[0], $scope);
                }
              }, function (reason) {
                youtubeInnerScope.loading = false;
                $rootScope.hideLinearProgress('#fetcherLoader');
                youtubeInnerScope.youtubeCollection = [];
              });
          } else {

            var errorMsg = channel + '<br/> Wrong Youtube link. <br/>' + (assetType === 'channel' ? 'Example #1: https://www.youtube.com/user/xxxxxxx <br/> Example #2: https://www.youtube.com/channel/xxxxxxxx'
              : 'Example: https://www.youtube.com/watch?v=xxxxxxx');

            ToastService.Big({
              title: 'Searching for',
              text: errorMsg,
              color: 'amber',
              icon: 'emoticon-sad'
            }, 60 * 1000);
          }

        };

        var inner = $templateCache.get('youtube-import.html');

        inner = $compile(inner)(youtubeInnerScope);

        $scope.window = ModalWindowService.Open({
          content: inner,
          isFixed: true,
          keyboard: true,
          actions: [
            {
              title: 'Import Selected',
              color: 'green',
              fn: function () {
                return youtubeInnerScope.searchFromYoutube(youtubeInnerScope.searchField);
              }
            },
            {
              title: 'Cancel',
              color: 'red'
            }
          ],
          size: {
            s: 10,
            l: 6
          }
        });
      };

      /**
       * Autofill data to asset
       */
      service.AutoFill = function (asset, data, $scope) {
        $scope.$parent.loading = true;
        $rootScope.showLinearProgress('#modalLoader');

        if (data) {

          var description = data.description;
          if (description) {
            asset.description = asset.description || description;
          }

          var title = data.title;
          if (title) {
            asset.title = asset.title || title;
          }

          if (!asset._PrivateData.posterNew) {
            asset._PrivateData.posterNew = data.logo;
            asset._PrivateData.posterUrl = data.logo;
          }

          if (asset._PrivateData.streamsResources['youtube']) {
            asset._PrivateData.posterNew = data.logo;
            asset._PrivateData.posterUrl = data.logo;

            if (title) {
              asset.title = title;
            }

            if (description) {
              asset.description = description;
            }
          }

          asset._PrivateData.categoriesNew = [];
          if ($scope.categorySearch && asset.type === 'channel') asset._PrivateData.categoriesNew = $scope.categorySearch.filter(function (category) {
            return category.title === 'TV';
          });

          if (asset.type !== 'channel') {
            asset.year = data.date.format('YYYY');
          }

          asset._PrivateData.streamsResources['youtube'] = {
            streamUrl: '',
            streamResourceId: null,
            title: MetadataService._STREAM_TYPES_ATTRS['youtube'].title || 'Unknown',
            placeholder: MetadataService._STREAM_TYPES_ATTRS['youtube'].placeholder || 'Unknown format',
            streamOld: '',
            streamNew: '',
            toDelete: false,
            stream_type: 'youtube',
            type: 'youtube_stream'
          };

          asset._PrivateData.streamsResources['youtube'].source = data.stream;

          $scope.$parent.loading = false;
          $rootScope.hideLinearProgress('#modalLoader');
          ToastService.Big({
            title: 'Import',
            text: 'Import from Youtube successfully finished. Check all fields before saving',
            color: 'green',
            icon: 'emoticon-happy'
          }, 10 * 60 * 1000);
        }
      };
      return service;
    }]);
